export default __webpack_public_path__ + "static/olivetree-logo.253ea7ca.svg";